import React from 'react';
import {
  LinkTrackingData,
  SearchCardType,
  TrackingDataEvent,
} from '../../../common/AnalyticsContext/LinkTracking';
import { InlineAd } from '../Inline/InlineAd';

export interface InstantScriptsInlineAdProps {
  resultType: 'standard' | 'extended';
  index: number;
  inSearchedSuburb?: boolean;
}

export const InstantScriptsInlineAd = ({
  resultType,
  inSearchedSuburb,
  index,
}: InstantScriptsInlineAdProps) => {
  const name: string = 'InstantScripts - Scripts & Medical Certificates';

  const findOutMoreUrl = 'https://healthengine.com.au/services/telehealth/instantscripts-selection';

  const clickTracking: LinkTrackingData = {
    event: TrackingDataEvent.SEARCH_RESULT_CARD,
    searchCardType: SearchCardType.PRACTICE,
    searchCardFeatured: false,
    searchCardResultsPosition: (index | 0) + 1,
    searchCardPriceVerified: false,
    searchCardSpecialOffer: false,
    searchResultIsInSuburb: inSearchedSuburb,
    searchResultType: resultType,
    practiceName: name,
  };

  return (
    <InlineAd
      profileName={name}
      profileBody="Receive a prescription or medical certificate from an Australian registered GP"
      logo="public/images/instantscripts_doctor_20220308022946.jpg"
      clickTracking={clickTracking}
      nextUrl={findOutMoreUrl}
      ctaText="Find out more"
      label="from $19 per request"
      featured
    />
  );
};
